/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, Heading, HFlow, Icon, ModalCloseButton, VFlow } from 'bold-ui'
import { resolveName } from 'components/form'
import { MutableRefObject } from 'react'
import { useField } from 'react-final-form'
import { MetaRoot } from 'util/metaPath'

import { getPerguntaAtivaInfo } from '../consulta-seguimento-aplicacao/utils-consultaSeguimentoAplicacao'
import { ConsultaSeguimentoPerguntasMap } from '../consultaSeguimentoPerguntasMap'
import { ConsultaSeguimentoFieldModel } from '../model-consultaSeguimento'

interface ConsultaSeguimentoModalTabAdicionarProps {
  path: MetaRoot<ConsultaSeguimentoFieldModel>
  backToSelecaoButtonRef: MutableRefObject<HTMLButtonElement>
  backQuestionButtonRef: MutableRefObject<HTMLButtonElement>
  onGoBackToSelecao: () => void
  onGoToPreviousQuestion: () => void
}

export function ConsultaSeguimentoModalTabAdicionar(props: Readonly<ConsultaSeguimentoModalTabAdicionarProps>) {
  const { path, backToSelecaoButtonRef, backQuestionButtonRef, onGoBackToSelecao, onGoToPreviousQuestion } = props

  const {
    input: { value: aplicacao },
  } = useField(resolveName(path.aplicacao), { subscription: { value: true } })

  const {
    input: { value: perguntasSelecionadas },
  } = useField(resolveName(path.perguntasSelecionadas), { subscription: { value: true } })

  const { perguntaAtiva, isFirst: isFirstPergunta } = getPerguntaAtivaInfo(aplicacao || {})

  const { Field } = ConsultaSeguimentoPerguntasMap[perguntaAtiva]

  return (
    <VFlow vSpacing={2}>
      <HFlow alignItems='flex-start' justifyContent='space-between'>
        {isFirstPergunta ? (
          <Button kind='normal' size='small' innerRef={backToSelecaoButtonRef} onClick={onGoBackToSelecao}>
            <Icon icon='arrowLeft' style={styles.backIcon} />
            Voltar à seleção
          </Button>
        ) : (
          <Button kind='normal' size='small' innerRef={backQuestionButtonRef} onClick={onGoToPreviousQuestion}>
            <Icon icon='arrowLeft' style={styles.backIcon} />
            Voltar
          </Button>
        )}
        <ModalCloseButton />
      </HFlow>
      <VFlow>
        <Heading level={1}>Entrevista de seguimento</Heading>
        <Field name={path.aplicacao[perguntaAtiva]} perguntasSelecionadas={perguntasSelecionadas} />
      </VFlow>
    </VFlow>
  )
}

const styles = {
  backIcon: css`
    margin-right: 0.5rem;
  `,
}
